import {
  LISTAFAMILIARES_SUCCESS,
  LISTAFAMILIARES_LOADING,
  LISTAFAMILIARES_ERROR,
  LISTAFAMILIARES_RESET,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosLogin from "../../../../global/helpers/axiosLogin";

export const getListaFamiliares = (imgPerfil) => (dispatch) => {
  dispatch({
    type: LISTAFAMILIARES_LOADING,
  });

 axiosLogin().then(respuesta => {
  respuesta
  .get(`/shared/Familia/listaFamiliares/${imgPerfil ? imgPerfil : false}`)
  .then((res) => {
    dispatch({
      type: LISTAFAMILIARES_SUCCESS,
      payload: res.data,
    });
  })
  .catch((err) => {
    let error = {
      detail: err.response
        ? err.response.data
        : "Error al contactar el server.",
    };

    dispatch({
      type: LISTAFAMILIARES_ERROR,
      payload: error,
    });
  });
 } )
};
// export const getListaFamiliares = (imgPerfil) => (dispatch) => {
//   dispatch({
//     type: LISTAFAMILIARES_LOADING,
//   });

//  axiosInstance().then(respuesta => {
//   respuesta
//   .get(`/familia/listaFamiliares/${imgPerfil ? imgPerfil : false}`)
//   .then((res) => {
//     dispatch({
//       type: LISTAFAMILIARES_SUCCESS,
//       payload: res.data,
//     });
//   })
//   .catch((err) => {
//     let error = {
//       detail: err.response
//         ? err.response.data
//         : "Error al contactar el server.",
//     };

//     dispatch({
//       type: LISTAFAMILIARES_ERROR,
//       payload: error,
//     });
//   });
//  } )
// };

export const resetListaFamiliares = () => (dispatch) => {
  dispatch({
    type: LISTAFAMILIARES_RESET,
  });
};
